import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../theme.factory';

@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html'
})
export class ThemeComponent implements OnInit {
  constructor(public themeService: ThemeService) {
  }

  ngOnInit(): void {
  }

  themesTrackBy(index, theme) {
    if (!theme) return null;
    return theme.code;
  }
}